const navigationItems = [
  {
    label: "Our Company",
    children: [
      {
        label: "Our History",
        href: "/our-company/our-history"
      },
      {
        label: "Strategy, Mission & Values",
        href: "/our-company/strategy-mission-values"
      },
      {
        label: "Leadership",
        href: "/our-company/leadership"
      },
      {
        label: "Investor Relations",
        href: "https://investor.columbia.com/",
        isExternal: true
      },
      {
        label: "Press Releases",
        href: "https://investor.columbia.com/news-events/press-releases",
        isExternal: true
      },
    ]
  },
    {
      label: "Careers",
      children: [
        {
          label: "Global Careers",
          href: "/careers",
        },
        {
          label: "Our Brands",
          children: [
            {
              label: "Columbia",
              href: "/careers/our-brands/columbia-careers",
            },
            {
              label: "SOREL",
              href: "/careers/our-brands/sorel-careers",
            },
            {
              label: "Mountain Hardwear",
              href: "/careers/our-brands/mountain-hardwear-careers",
            },
            {
              label: "prAna",
              href: "/careers/our-brands/prana-careers",
            }
          ]
        },
        {
          label: "Our Regions & Locations",
          children: [
            {
              label: "North America",
              href: "/careers/regions-group/north-america",
            },
            {
              label: "Asia",
              href: "/careers/regions-group/asia",
            },
            {
              label: "Europe",
              href: "/careers/regions-group/europe",
            }
          ]
        },
        {
          label: "Life at CSC",
          children: [
            {
              label: "Wellbeing & Benefits",
              href: "/our-company/wellbeing-benefits"
            },
            {
              label: "Inclusion & Diversity",
              href: "/our-company/inclusion-diversity"
            },
          ]
        }
      ]
    },
  {
    label: "Corporate Responsibility",
    children: [
      {
        label: "Overview",
        href: "/corporate-responsibility/overview"
      },
      {
        label: "Highlights",
        href: "/corporate-responsibility/highlights"
      },
      {
        label: "Impact Report",
        href: "/corporate-responsibility/impact"
      },
      {
        label: "Empowering People",
        href: "/corporate-responsibility/empowering-people"
      },
      {
        label: "Sustaining Places",
        href: "/corporate-responsibility/sustaining-places"
      },
      {
        label: "Responsible Practices",
        href: "/corporate-responsibility/responsible-practices"
      }
    ]
  },
  {
    label: "Shop",
    children: [
      {
        label: "Columbia",
        href: "https://www.columbia.com",
        isExternal: true,
        logo: 'colLogo'
      },
      {
        label: "Mountain Hardwear",
        href: "https://www.mountainhardwear.com/",
        isExternal: true,
        logo: 'mhwLogo'
      },
      {
        label: "SOREL",
        href: "https://www.sorel.com/",
        isExternal: true,
        logo: 'sorLogo'
      },
      {
        label: "prAna",
        href: "https://www.prana.com/",
        isExternal: true,
        logo: 'praLogo'
      },
    ]
  }
];

export default navigationItems;
